import React from 'react';
import MainContainer from '@components/mainContainer/MainContainer';
import MainHeader from '@components/mainHeader/MainHeader';
import { LayoutProps } from './Layout.types';
import { Container, StyledMain } from './LoggedLayout.styles';

const LoggedLayout = (props: LayoutProps) => {
  const { children } = props;

  return (
    <Container>
      <StyledMain>
        <MainHeader />
        <MainContainer>{children}</MainContainer>
      </StyledMain>
    </Container>
  );
};

export default LoggedLayout;
